<template>
  <div id="featured-vehicles-component-v2" class="sokal-modern-styles" :data-brand="this.$store.state.chosenBrand">
    <div class="featured-car-bg">
      <div class="sokal-container">
        <div class="row">
          <div class="col-sm-8 col-sm-offset-2 col-xs-12 featured-car-border">
            <h2 class="text-center">Your Featured Vehicles</h2>
          </div>
        </div>
        <div class="row flex-row">
          <div class="col-md-3 col-sm-6 col-xs-12 fv-block">
            <div class="fv-wrapper sokal-relative">
              <div class="fv-car-img sokal-media-container">
                <a href="#">
                  <img class="sokal-media-cover" :alt="brandName" :src="vehicleOne.angleView">
                </a>
              </div>
              <div class="fv-car-data">
                <div class="specs">
                  <h3 class="fv-title-heading">
                    <a href="#" class="fv-title-link">
                      <span class="fv-year">2023</span>
                      <span class="fv-model">{{vehicleOne.modelName}}</span>
                      <span class="fv-trim">{{vehicleOne.trims[0]}}</span>
                    </a>
                  </h3>
                <div class="fv-mileage">Mileage: <span>20</span></div>
                <div class="fv-color-ext">Exterior Color: <span v-for="(color, index) in brandColors[0]" :key="index">{{ color }}</span></div>
                </div>
                <a v-if="isInfiniti" class="sokal-btn sokal-btn-primary has-border-radius" href="#">
                  <div class="sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-center">
                    <span class="sokal-btn-copy">Learn More</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1.6em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </a>
                <a v-else alt="Learn More" class="sokal-btn sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-center btn" :class="[brand === 'toyota' || brand === 'nissan' ? 'secondary-btn' : 'primary-btn', brandName.toLowerCase() + '-btn']" href="#">
                  <div class="span sokal-btn-copy">Learn More</div>
                  <svg class="feather feather-arrow-right" fill="none" height="1.6em" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="1.13em" xmlns="http://www.w3.org/2000/svg"><line x1="5" x2="19" y1="12" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12 fv-block">
            <div class="fv-wrapper sokal-relative">
              <div class="fv-car-img sokal-media-container">
                <a href="#">
                  <img class="sokal-media-cover" :alt="brandName" :src="vehicleTwo.angleView">
                </a>
              </div>
              <div class="fv-car-data">
                <div class="specs">
                  <h3 class="fv-title-heading">
                    <a href="" class="fv-title-link">
                      <span class="fv-year">2021</span>
                      <span class="fv-model">{{vehicleTwo.modelName}}</span>
                      <span class="fv-trim">{{vehicleTwo.trims[1]}}</span>
                    </a>
                  </h3>
                  <div class="fv-mileage">Mileage: <span>34,560</span></div>
                  <div class="fv-color-ext">Exterior Color: <span v-for="(color, index) in brandColors[1]" :key="index">{{ color }}</span></div>
                </div>
                <a v-if="isInfiniti" class="sokal-btn sokal-btn-primary has-border-radius" href="#">
                  <div class="sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-center">
                    <span class="sokal-btn-copy">Learn More</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1.6em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </a>
                <a v-else alt="Learn More" class="sokal-btn sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-center btn" :class="[brand === 'toyota' || brand === 'nissan' ? 'secondary-btn' : 'primary-btn', brandName.toLowerCase() + '-btn']" href="#">
                  <div class="span sokal-btn-copy">Learn More</div>
                  <svg class="feather feather-arrow-right" fill="none" height="1.6em" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="1.13em" xmlns="http://www.w3.org/2000/svg"><line x1="5" x2="19" y1="12" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12 fv-block">
            <div class="fv-wrapper sokal-relative">
              <div class="fv-car-img sokal-media-container">
                <a href="#">
                  <img class="sokal-media-cover" :alt="brandName" :src="vehicleThree.angleView">
                </a>
              </div>
              <div class="fv-car-data">
                <div class="specs">
                  <h3 class="fv-title-heading">
                    <a href="" class="fv-title-link">
                      <span class="fv-year">2022</span>
                      <span class="fv-model">{{vehicleThree.modelName}}</span>
                      <span class="fv-trim">{{vehicleThree.trims[2]}}</span>
                    </a>
                  </h3>
                  <div class="fv-mileage">Mileage: <span>11,879</span></div>
                  <div class="fv-color-ext">Exterior Color: <span v-for="(color, index) in brandColors[2]" :key="index">{{ color }}</span></div>
                </div>
                <a v-if="isInfiniti" class="sokal-btn sokal-btn-primary has-border-radius" href="#">
                  <div class="sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-center">
                    <span class="sokal-btn-copy">Learn More</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1.6em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </a>
                <a v-else alt="Learn More" class="sokal-btn sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-center btn" :class="[brand === 'toyota' || brand === 'nissan' ? 'secondary-btn' : 'primary-btn', brandName.toLowerCase() + '-btn']" href="#">
                  <div class="span sokal-btn-copy">Learn More</div>
                  <svg class="feather feather-arrow-right" fill="none" height="1.6em" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="1.13em" xmlns="http://www.w3.org/2000/svg"><line x1="5" x2="19" y1="12" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-xs-12 fv-block">
            <div class="fv-wrapper sokal-relative">
              <div class="fv-car-img sokal-media-container">
                <a href="#">
                  <img class="sokal-media-cover" :alt="brandName" :src="vehicleFour.angleView">
                </a>
              </div>
              <div class="fv-car-data">
                <div class="specs">
                  <h3 class="fv-title-heading">
                    <a href="" class="fv-title-link">
                      <span class="fv-year">2023</span>
                      <span class="fv-model">{{vehicleFour.modelName}}</span>
                      <span class="fv-trim">{{vehicleFour.trims[1]}}</span>
                    </a>
                  </h3>
                  <div class="fv-mileage">Mileage: <span>10</span></div>
                  <div class="fv-color-ext">Exterior Color: <span v-for="(color, index) in brandColors[3]" :key="index">{{ color }}</span></div>
                </div>
                <a v-if="isInfiniti" class="sokal-btn sokal-btn-primary has-border-radius" href="#">
                  <div class="sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-center">
                    <span class="sokal-btn-copy">Learn More</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="1.13em" height="1.6em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-right">
                      <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                  </div>
                </a>
                <a v-else alt="Learn More" class="sokal-btn sokal-flex sokal-flex-row sokal-gap sokal-items-center sokal-justify-center btn" :class="[brand === 'toyota' || brand === 'nissan' ? 'secondary-btn' : 'primary-btn', brandName.toLowerCase() + '-btn']" href="#">
                  <div class="span sokal-btn-copy">Learn More</div>
                  <svg class="feather feather-arrow-right" fill="none" height="1.6em" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="1.13em" xmlns="http://www.w3.org/2000/svg"><line x1="5" x2="19" y1="12" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      // brand: this.$store.state.chosenBrand,
      activeClass: 'active',
      brandColorConfig: {
        infiniti: ['Graphite Shadow', 'Radiant White', 'Black Obsidian', 'Slate Gray'],
        ford: ['Oxford White', 'Agate Black', 'Velocity Blue', 'Silver Metallic'],
        hyundai: ['Ultimate Red', 'Shimmering Silver', 'Deep Sea', 'Ash Black']
      },
    }
  },
  computed: {
    brand() {
      return this.$store.state.chosenBrand
        ? this.$store.state.chosenBrand.toLowerCase()
        : 'none';
    },
    brandName () {
      if (this.brand === 'none') {
        return 'default';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    brandColors() {
      return this.brandColorConfig[this.brand] || [];
    },
    isInfiniti () {
      if (this.brand.toLowerCase() === 'infiniti') {
        return true;
      } else {
        return false;
      }
    },
    vehicleOne () {
      if (this.images.sedans.length > 0) {
        return this.images.sedans[0];
      } else {
        return this.images.suvs[0];
      }
    },
    vehicleTwo () {
      if (this.images.sedans.length > 0) {
        return this.images.suvs[0];
      } else {
        return this.images.suvs[1];
      }
    },
    vehicleThree () {
      if (this.images.sedans.length > 0) {
        return this.images.suvs[1];
      } else {
        return this.images.suvs[2];
      }
    },
    vehicleFour () {
      if (this.images.trucks.length > 0) {
        return this.images.trucks[0];
      } else if (this.images.sedans.length > 0) {
        return this.images.suvs[2];
      } else {
        return this.images.suvs[3];
      }
    },
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>

  #featured-vehicles-component-v2 {
    padding-bottom: 50px;
  }

  #featured-vehicles-component-v2 .featured-car-border h2 {
    margin: 30px auto;
  }

  #featured-vehicles-component-v2 .fv-wrapper {
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    padding: 0;
    width: 100%;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
    transition: all 0.3s ease-in-out;
    position: relative;
    overflow: hidden;
  }

  #featured-vehicles-component-v2 .fv-wrapper:hover {
    transform: scale(1.05);
    -webkit-box-shadow: 0px 0px 15px 7px #76767627;
    box-shadow: 0px 0px 15px 7px #76767627;
  }

  #featured-vehicles-component-v2 .fv-wrapper::after {
    display: block;
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 5px;
    background-color: transparent;
    transition: all 0.3s ease-in-out;
  }

  #featured-vehicles-component-v2 .fv-wrapper:hover::after {
    background-color: var(--primary-color, #000000);
    width: 100%;
  }

  #featured-vehicles-component-v2 .fv-wrapper .fv-title-link {
    margin-bottom: 10px;
    color: var(--primary-color, #000000);
    display: flex;
    flex-flow: column nowrap;
    gap: 5px;
  }

  #featured-vehicles-component-v2 .fv-wrapper .fv-title-link:hover,
  #featured-vehicles-component-v2 .fv-wrapper .fv-title-link:focus,
  #featured-vehicles-component-v2 .fv-wrapper .fv-title-link:focus-visible {
    text-decoration: none;
    outline: none;
  }

  #featured-vehicles-component-v2 .fv-block .fv-car-data {
    padding: 15px 15px 30px;
    height: auto;
    width: 100%;
  }

  #featured-vehicles-component-v2 .fv-wrapper .fv-car-img img {
    border-radius: 6px;
    width: 100%;
    float: left;
  }

  #featured-vehicles-component-v2 .specs {
    display: flex;
    flex-direction: column;
    color: #000000;
  }

  #featured-vehicles-component-v2 .fv-year {
    font-size: 14px;
    border-bottom: 3px solid var(--primary-color, #000000);
    width: fit-content;
  }

  #featured-vehicles-component-v2 .fv-model {
    font-size: 16px;
  }

  #featured-vehicles-component-v2 .fv-trim {
    font-size: 12px;
  }
  
  #featured-vehicles-component-v2 .fv-color-ext {
    border-top: solid 1px #999999;
    padding-bottom: 10px;
  }
  
  #featured-vehicles-component-v2 .fv-color-ext span,
  #featured-vehicles-component-v2 .fv-mileage span {
    font-weight: lighter;
    color: #767676;
  }

  #featured-vehicles-component-v2 .fv-mileage,
  .fv-color-ext {
    font-size: 13px;
    font-weight: bold;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    padding-top: 5px;
    margin-bottom: 5px;
  }

  #featured-vehicles-component-v2 .fv-title-heading,
  #featured-vehicles-component-v2 .fv-year,
  #featured-vehicles-component-v2 .fv-model,
  #featured-vehicles-component-v2 .fv-trim {
    font-family: var(--heading-text);
  }

  #featured-vehicles-component-v2 .fv-car-data .sokal-btn {
    display: flex;
    background-color: var(--primary-dark, #000000);
    color: #ffffff;
    border: 1px solid var(--primary-dark, #000000);
    font-weight: bold;
    font-size: 16px;
    font-weight: 500;
    border-radius: var(--brand-br, 4px);
    -webkit-transition: .3s all ease-in-out;
    -o-transition: .3s all ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    transition: .3s all ease-in-out;
    width: fit-content;
    position: relative;
    overflow: hidden;
  }

  #featured-vehicles-component-v2 .fv-car-data .sokal-btn-copy {
    transition: transform 0.3s ease-in-out;
  }

  #featured-vehicles-component-v2 .fv-car-data svg.feather-arrow-right {
    opacity: 0;
    position: absolute;
    right: 10px;
    transform: translateX(10px);
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  }

  #featured-vehicles-component-v2 .fv-car-data .sokal-btn:hover .sokal-btn-copy {
    transform: translateX(-10px);
    margin-right: 0;
  }

  #featured-vehicles-component-v2 .fv-car-data .sokal-btn:hover svg.feather-arrow-right {
    opacity: 1;
    transform: translateX(0);
  }

  @media (min-width: 768px) {

    #featured-vehicles-component-v2 .sokal-container {
      width: 750px;
    }

    #featured-vehicles-component-v2 .fv-trim-spacer {
      height: 12px;
    }
    
  }

  @media (min-width: 992px) {
    #featured-vehicles-component-v2 .sokal-container {
      width: 970px;
    }
  }

  @media (min-width: 1200px) {
    
    #featured-vehicles-component-v2 .sokal-container {
      width: 1170px;
    }

    #featured-vehicles-component-v2 .fv-wrapper:hover .fv-car-img img {
      border-radius: 6px 6px 0px 0px;
    }

  }

  @media (max-width: 767px) {
    #featured-vehicles-component-v2 .fv-block {
      width: 95%;
      margin-left: 2.5%;
    }
  }

  @media (max-width: 991px) {
    #featured-vehicles-component-v2 .fv-block {
      margin-bottom: 3em;
    }
  }

  @media (max-width: 1199px) {
    #featured-vehicles-component-v2 .fv-wrapper .fv-car-img img {
      border-radius: 6px 6px 0px 0px;
    }
  }
</style>

<!-- MODERN UTILITY CLASSES -->

<style scoped>

.has-border-radius {
    --sokal-has-border-radius-value: 50px;
}

  /* General */

.container-content {
  max-width: 1500px;
  padding: 15px;
  margin-left: auto;
  margin-right: auto;
}

.width-100-percent {
  width: 100%;
}

.width-fit-content {
  width: fit-content;
}

.svg-responsive, 
.svg-responsive-wrapper svg {
  max-width: 100%;
  max-height: 100%;
}

.height-100-percent {
  height: 100%;
}

.has-border-radius {
  overflow: hidden;
  border-radius: 10px;
  border-radius: var(--sokal-has-border-radius-value, 10px);
}

.vertical-spacer-10px {
  height: 10px;
}

.vertical-spacer-15px {
  height: 20px;
}

.vertical-spacer-30px {
  height: 30px;
}

.opacity-70-percent {
  opacity: 0.7;
}

.visibility-hidden {
  visibility: hidden;
}

.display-flex-center-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sokal-relative {
  position: relative;
}

/* Animations */

@keyframes sokalContentFadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.sokal-content-fade-in {
  animation: 1.5s ease-in 0s sokalContentFadeIn;
}

/* Buttons */

.sokal-btn, 
.vehicle-buttons .sokal-btn {
  font-size: .875em;
  font-weight: normal;
  line-height: calc(0.875em + 2px);
  text-align: center;
  text-decoration: none;
  min-height: 48px;
  width: 100%;
  padding: 16px 40px;
  border: 1px solid #000000;
  border: 1px solid var(--primary-dark, #000000);
  display: inline-block;
  position: relative;
  z-index: 0;
  -moz-transition: color ease-in-out .15s;
  -webkit-transition: color ease-in-out .15s;
  transition: color ease-in-out .15s;
}

.sokal-btn.dark-theme, 
.vehicle-buttons .sokal-btn.dark-theme {
  border-color: #ffffff;
}

.sokal-btn::after, 
.vehicle-buttons .sokal-btn::after {
  content: "";
  display: block;
  width: 0px;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  -moz-transition: width .1s ease-in-out;
  -webkit-transition: width .1s ease-in-out;
  transition: width .1s ease-in-out;
}

.sokal-btn:hover, 
.sokal-btn:focus, 
.vehicle-buttons .sokal-btn:hover, 
.vehicle-buttons .sokal-btn:focus {
  text-decoration: none;
}

.sokal-btn:hover::after, 
.sokal-btn:focus::after, 
.vehicle-buttons .sokal-btn:hover::after, 
.vehicle-buttons .sokal-btn:focus::after {
  width: 100%;
  left: 0;
  -moz-transition: width ease-in-out .2s;
  -webkit-transition: width ease-in-out .2s;
  transition: width ease-in-out .2s;
}

@media screen and (min-width: 576px) {

  .sokal-btn {
    width: auto;
  }

}

/* Primary Button */

.sokal-btn-primary {
  --sokal-btn-background: var(--primary-dark, #000000);
  --sokal-btn-color: #ffffff;
}

.sokal-btn-primary.dark-theme {
  --sokal-btn-background: #ffffff;
  --sokal-btn-color: var(--primary-dark, #000000);
}

.sokal-btn-primary, 
.vehicle-buttons .sokal-btn-primary {
  background: #000000;
  background: var(--sokal-btn-background);
  color: #ffffff;
  color: var(--sokal-btn-color);
}

.sokal-btn-primary.dark-theme, 
.vehicle-buttons .sokal-btn-primary.dark-theme {
  background: #ffffff;
  background: var(--sokal-btn-background);
  color: #000000;
  color: var(--sokal-btn-color);
}

.sokal-btn-primary::after, 
.vehicle-buttons .sokal-btn-primary::after {
  background: #ffffff;
  background: var(--sokal-btn-color);
}

.sokal-btn-primary.dark-theme::after, 
.vehicle-buttons .sokal-btn-primary.dark-theme::after {
  background: #000000;
  background: var(--sokal-btn-color);
}

.sokal-btn-primary:hover, 
.sokal-btn-primary:focus, 
.vehicle-buttons .sokal-btn-primary:hover, 
.vehicle-buttons .sokal-btn-primary:focus {
  color: #000000;
  color: var(--sokal-btn-background);
}

.sokal-btn-primary.dark-theme:hover, 
.sokal-btn-primary.dark-theme:focus, 
.vehicle-buttons .sokal-btn-primary.dark-theme:hover, 
.vehicle-buttons .sokal-btn-primary.dark-theme:focus {
  color: #ffffff;
  color: var(--sokal-btn-background);
}

/* Secondary Button */

.sokal-btn-secondary {
  --sokal-btn-background: #ffffff;
  --sokal-btn-color: var(--primary-dark, #000000);
}

.sokal-btn-secondary.dark-theme {
  --sokal-btn-background: var(--primary-dark, #000000);
  --sokal-btn-color: #ffffff;
}

.sokal-btn-secondary, 
.vehicle-buttons .sokal-btn-secondary {
  background: #ffffff;
  background: var(--sokal-btn-background);
  color: #000000;
  color: var(--sokal-btn-color);
}

.sokal-btn-secondary.dark-theme, 
.vehicle-buttons .sokal-btn-secondary.dark-theme {
  background: #000000;
  background: var(--sokal-btn-background);
  color: #ffffff;
  color: var(--sokal-btn-color);
}

.sokal-btn-secondary::after, 
.vehicle-buttons .sokal-btn-secondary::after {
  background: #000000;
  background: var(--sokal-btn-color);
}

.sokal-btn-secondary.dark-theme::after, 
.vehicle-buttons .sokal-btn-secondary.dark-theme::after {
  background: #ffffff;
  background: var(--sokal-btn-color);
}

.sokal-btn-secondary:hover, 
.sokal-btn-secondary:focus, 
.vehicle-buttons .sokal-btn-secondary:hover, 
.vehicle-buttons .sokal-btn-secondary:focus {
  color: #ffffff;
  color: var(--sokal-btn-background);
}

.sokal-btn-secondary.dark-theme:hover, 
.sokal-btn-secondary.dark-theme:focus, 
.vehicle-buttons .sokal-btn-secondary.dark-theme:hover, 
.vehicle-buttons .sokal-btn-secondary.dark-theme:focus {
  color: #000000;
  color: var(--sokal-btn-background);
}

/* Links */

.sokal-link {
  font-size: 0.75em;
  line-height: calc(0.75em + 2px);
  display: inline-block;
}

.sokal-link, 
.sokal-link:hover, 
.sokal-link:focus {
  color: #000000;
  color: var(--primary-dark, #000000);
  text-decoration: none;
}

.sokal-link.dark-theme, 
.sokal-link.dark-theme:hover, 
.sokal-link.dark-theme:focus {
  color: #ffffff;
}

.sokal-link-copy {
  position: relative;
}

.sokal-link-copy::after {
  content: "";
  display: block;
  width: 0px;
  border-bottom: 1px solid;
  position: relative;
  bottom: -3px;
  left: 0;
  -moz-transition: width ease-in-out .1s;
  -webkit-transition: width ease-in-out .1s;
  transition: width ease-in-out .1s;
}

/* Primary Link */

.sokal-link-primary:hover .sokal-link-copy::after,
.sokal-link-primary:focus .sokal-link-copy::after {
  width: 100%;
}
.sokal-link-primary .sokal-link-copy::after {
  content: "";
  display: block;
  width: 0px;
  border-bottom: 1px solid;
  position: relative;
  bottom: -3px;
  left: 0;
  box-sizing: border-box;
  transition: width ease-in-out .1s;
}

/* Secondary Link */

.sokal-link-secondary:hover .sokal-link-copy::after, 
.sokal-link-secondary:focus .sokal-link-copy::after {
  width: 100%;
}

/* Search Bar Solid */

.search-bar--solid .input-search, 
.search-bar--solid .input-search::placeholder, 
.search-bar--solid .search-submit-btn {
  color: var(--primary-dark, #000000);
}

.search-bar--solid .input-search, 
.search-bar--solid .search-submit-btn {
  padding: 6px 20px;
}

.search-bar--solid .input-search, 
.search-bar--solid .input-search:focus, 
.search-bar--solid .search-submit-btn {
  border-color: #ffffff;
}

.search-bar--solid .input-search {
  background-color: #ffffff;
}

.search-bar--solid .input-search:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.search-bar--solid .search-submit-btn {
  font-size: 17px;
}

.search-bar--solid .search-submit-btn:focus {
  outline: none;
}

/* Search Bar Round */

.search-bar--round .input-search {
  border-radius: 50px 0 0 50px;
}

.search-bar--round .input-group-btn:last-child > .btn, 
.search-bar--round .input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}

/* Tabs */

.nav-tabs .flex-tab, 
.nav-btn-tabs .flex-tab {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.nav-btn-tabs > li {
  margin-right: 2px;
  background-color: #F6F8F9;
  border: 1px solid transparent;
}

.nav-tabs .flex-tab a, 
.nav-tabs .flex-tab .flex-tab-item, 
.nav-btn-tabs .flex-tab a, 
.nav-btn-tabs .flex-tab .flex-tab-item {
  padding: 10px 0;
}

.nav-btn-tabs > li > a:hover, 
.nav-btn-tabs > li > a:active, 
.nav-btn-tabs > li > a:focus {
  background-color: transparent;
}

.nav-btn-tabs > li.active {
  background-color: #ffffff;
  border-color: #ddd;
}

/* Selects */

li:not(.active) .editable-template-select, 
li.active .editable-template-select-disabled {
  display: none;
}

/* Textareas */

.html-textarea-editor {
  width: 100%;
  height: 500px;
  max-height: 100%;
}

[data-toggle="collapse"]:not(.collapsed) .show-collapsed, 
[data-toggle="collapse"].collapsed .show-expanded {
  display: none;
}

</style>




<!-- SOKAL UTILITY CLASSES -->

<style scoped>
  .sokal-container {
  max-width: 1500px;
  padding: 0 1em;
  margin-left: auto;
  margin-right: auto; }

@media only screen and (min-width: 1513px) {
  .sokal-container:has(.sokal-fullwidth-block) > *:not(.sokal-p-0) {
    padding-left: 1em;
    padding-right: 1em; } }

.sokal-before-none::before,
.sokal-after-none::after {
  display: none; }

.sokal-hr {
  height: 1px;
  width: 100%;
  margin: 1em auto;
  background-color: #DDE3E8; }

.sokal-border-solid {
  border: solid 1px; }

.sokal-space-y-05 {
  height: 0.5em; }

.sokal-space-y-1 {
  height: 1em; }

.sokal-space-y-2 {
  height: 2em; }

.sokal-space-y-3 {
  height: 3em; }

.sokal-space-y-4 {
  height: 4em; }

.sokal-space-x-05 {
  width: 0.5em; }

.sokal-space-x-1 {
  width: 1em; }

.sokal-space-x-2 {
  width: 2em; }

.sokal-space-x-3 {
  width: 3em; }

.sokal-space-x-4 {
  width: 4em; }

.sokal-w-auto {
  width: auto; }

.sokal-w-full {
  width: 100%; }

.sokal-w-fit-content {
  width: fit-content; }

.sokal-h-auto {
  height: auto; }

.sokal-h-full {
  height: 100%; }

.sokal-max-w-full {
  max-width: 100%; }

.sokal-max-h-full {
  max-height: 100%; }

.sokal-m-0 {
  margin: 0; }

.sokal-my-05 {
  margin-top: 0.5em;
  margin-bottom: 0.5em; }

.sokal-my-1 {
  margin-top: 1em;
  margin-bottom: 1em; }

.sokal-my-2 {
  margin-top: 2em;
  margin-bottom: 2em; }

.sokal-my-3 {
  margin-top: 3em;
  margin-bottom: 3em; }

.sokal-my-4 {
  margin-top: 4em;
  margin-bottom: 4em; }

.sokal-mx-05 {
  margin-left: 0.5em;
  margin-right: 0.5em; }

.sokal-mx-1 {
  margin-left: 1em;
  margin-right: 1em; }

.sokal-mx-2 {
  margin-left: 2em;
  margin-right: 2em; }

.sokal-mx-3 {
  margin-left: 3em;
  margin-right: 3em; }

.sokal-mx-4 {
  margin-left: 4em;
  margin-right: 4em; }

.sokal-mt-0 {
  margin-top: 0; }

.sokal-mr-0 {
  margin-right: 0; }

.sokal-mb-0 {
  margin-bottom: 0; }

.sokal-ml-0 {
  margin-left: 0; }

.sokal-p-0 {
  padding: 0; }

.sokal-px-05 {
  padding-left: 0.5em;
  padding-right: 0.5em; }

.sokal-px-1 {
  padding-left: 1em;
  padding-right: 1em; }

.sokal-px-2 {
  padding-left: 2em;
  padding-right: 2em; }

.sokal-px-3 {
  padding-left: 3em;
  padding-right: 3em; }

.sokal-px-4 {
  padding-left: 4em;
  padding-right: 4em; }

.sokal-py-05 {
  padding-top: 0.5em;
  padding-bottom: 0.5em; }

.sokal-py-1 {
  padding-top: 1em;
  padding-bottom: 1em; }

.sokal-py-2 {
  padding-top: 2em;
  padding-bottom: 2em; }

.sokal-py-3 {
  padding-top: 3em;
  padding-bottom: 3em; }

.sokal-py-4 {
  padding-top: 4em;
  padding-bottom: 4em; }

.sokal-pt-0 {
  padding-top: 0; }

.sokal-pr-0 {
  padding-right: 0; }

.sokal-pb-0 {
  padding-bottom: 0; }

.sokal-pl-0 {
  padding-left: 0; }

.sokal-align-middle {
  vertical-align: middle; }

.sokal-block {
  display: block; }

.sokal-inline-block {
  display: inline-block; }

.sokal-flex {
  display: flex; }

.sokal-inline-flex {
  display: inline-flex; }

.sokal-flex-row {
  flex-direction: row; }

.sokal-flex-row-reverse {
  flex-direction: row-reverse; }

.sokal-flex-col {
  flex-direction: column; }

.sokal-flex-col-reverse {
  flex-direction: column-reverse; }

.sokal-relative {
  position: relative; }

.sokal-absolute {
  position: absolute; }

.sokal-overflow-hidden {
  overflow: hidden; }

.sokal-items-start {
  align-items: start; }

.sokal-items-end {
  align-items: end; }

.sokal-items-center {
  align-items: center; }

.sokal-items-stretch {
  align-items: stretch; }

.sokal-justify-normal {
  justify-content: normal; }

.sokal-justify-start {
  justify-content: start; }

.sokal-justify-end {
  justify-content: end; }

.sokal-justify-center {
  justify-content: center; }

.sokal-justify-between {
  justify-content: space-between; }

.sokal-justify-around {
  justify-content: space-around; }

.sokal-justify-evenly {
  justify-content: space-evenly; }

.sokal-justify-stretch {
  justify-content: stretch; }

.sokal-flex-wrap {
  flex-wrap: wrap; }

.sokal-flex-nowrap {
  flex-wrap: nowrap; }

.sokal-grow {
  flex-grow: 1; }

.sokal-grow-0 {
  flex-grow: 0; }

.sokal-flex-1 {
  flex: 1 1 0%; }

.sokal-flex-auto {
  flex: 1 1 auto; }

.sokal-flex-initial {
  flex: 0 1 auto; }

.sokal-flex-none {
  flex: none; }

.sokal-gap {
  gap: 15px;
  gap: var(--sokal-gap-value, 15px); }

.sokal-gap-0 {
  gap: 0; }

.sokal-bg-primary {
  background-color: #333333;
  background-color: var(--primary-color, #333333); }

.sokal-color-primary {
  color: #333333;
  color: var(--primary-color, #333333); }

.sokal-border-color-primary {
  border-color: #333333;
  border-color: var(--primary-color, #333333); }

.sokal-bg-dark {
  background-color: #000000;
  background-color: var(--primary-dark, #000000); }

.sokal-color-dark {
  color: #000000;
  color: var(--primary-dark, #000000); }

.sokal-border-color-dark {
  border-color: #000000;
  border-color: var(--primary-dark, #000000); }

.sokal-bg-light {
  background-color: #F6F8F9;
  background-color: var(--primary-light, #F6F8F9); }

.sokal-color-light {
  color: #F6F8F9;
  color: var(--primary-light, #F6F8F9); }

.sokal-border-color-light {
  border-color: #F6F8F9;
  border-color: var(--primary-light, #F6F8F9); }

.sokal-bg-accent {
  background-color: #007bff;
  background-color: var(--secondary-color, #007bff); }

.sokal-color-accent {
  color: #007bff;
  color: var(--secondary-color, #007bff); }

.sokal-border-color-accent {
  border-color: #007bff;
  border-color: var(--secondary-color, #007bff); }

.sokal-border-color-gray {
  border-color: #E2E7EB; }

.sokal-bg-layer {
  position: relative; }

.sokal-bg-layer.has-border-radius {
  border-radius: 1em; }
  .sokal-bg-layer.has-border-radius * {
    border-radius: inherit; }

.sokal-bg-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; }

.sokal-bg-cover.extended-width {
  left: -100vw;
  width: 200vw; }

.sokal-bg-cover ~ * {
  position: relative; }

.sokal-box-shadow {
  -webkit-box-shadow: 0px 6px 10px #C7C7C729;
  box-shadow: 0px 6px 10px #C7C7C729; }

.sokal-icon {
  font-size: 1em;
  padding: 0.85em 0.81em;
  border-radius: 100%; }

.sokal-icon-shadow {
  -webkit-box-shadow: inset -5px 5px 6px #EDF2F5C4, -3px 5px 6px #EDF2F5;
  box-shadow: inset -5px 5px 6px #EDF2F5C4, -3px 5px 6px #EDF2F5; }

.sokal-icon-md {
  font-size: 1.5em; }

.sokal-icon-lg {
  font-size: 2.5em; }

.sokal-media-container {
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  overflow: hidden; }

.sokal-media-container.format-landscape-sm {
  padding-top: 40.25%; }

.sokal-media-container.format-portrait {
  padding-top: 110%; }

.sokal-media-container.format-square {
  padding-top: 100%; }

.sokal-media-container.has-border-radius {
  border-radius: 1em; }
  .sokal-media-container.has-border-radius * {
    border-radius: inherit; }

.sokal-media-cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover; }

.sokal-overlay:not(.relative) {
  position: absolute;
  top: 0;
  left: 0; }
  .sokal-overlay:not(.relative):not([class*="sokal-w-"]) {
    width: 100%; }
  .sokal-overlay:not(.relative):not([class*="sokal-h-"]) {
    height: 100%; }

.sokal-overlay.relative {
  position: relative; }

.sokal-card {
  padding: 3.5em 2em;
  max-width: 100%; }

.sokal-card-tall {
  min-height: 27em;
  padding-top: 5em;
  padding-bottom: 5em; }

.sokal-card:not([class*="sokal-w-"]) {
  width: 20em; }

.sokal-flex > .sokal-card:not([class*="sokal-w-"]) {
  min-width: 20em; }

.sokal-card.has-border-radius {
  border-radius: 0.67em; }

.sokal-select-container {
  position: relative; }
  .sokal-select-container:not([class*="sokal-w-"]) {
    width: fit-content; }
  .sokal-select-container .sokal-select {
    -webkit-appearance: none;
    appearance: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    padding: 0.5em 1.2em 0.5em 0;
    border: 0;
    background-color: transparent;
    border-bottom: solid 1px #d3d3d3;
    border-radius: 0;
    position: relative;
    z-index: 2; }
    .sokal-select-container .sokal-select:hover {
      cursor: pointer; }
  .sokal-select-container .sokal-select + .fa,
  .sokal-select-container .sokal-select + svg {
    font-size: 0.8em;
    color: #bbbbbb;
    position: absolute;
    z-index: 1;
    top: 50%;
    right: 0;
    transform: translateY(-50%); }

@media only screen and (min-width: 768px) {
  .text-sm-left {
    text-align: left; }
  .text-sm-center {
    text-align: center; }
  .text-sm-right {
    text-align: right; }
  .sokal-sm-block {
    display: block; }
  .sokal-sm-inline-block {
    display: inline-block; }
  .sokal-sm-flex {
    display: flex; }
  .sokal-sm-inline-flex {
    display: inline-flex; }
  .sokal-sm-flex-row {
    flex-direction: row; }
  .sokal-sm-flex-row-reverse {
    flex-direction: row-reverse; }
  .sokal-sm-flex-col {
    flex-direction: column; }
  .sokal-sm-flex-col-reverse {
    flex-direction: column-reverse; }
  .sokal-sm-items-start {
    align-items: start; }
  .sokal-sm-items-end {
    align-items: end; }
  .sokal-sm-items-center {
    align-items: center; }
  .sokal-sm-items-stretch {
    align-items: stretch; }
  .sokal-sm-justify-normal {
    justify-content: normal; }
  .sokal-sm-justify-start {
    justify-content: start; }
  .sokal-sm-justify-end {
    justify-content: end; }
  .sokal-sm-justify-center {
    justify-content: center; }
  .sokal-sm-justify-between {
    justify-content: space-between; }
  .sokal-sm-justify-around {
    justify-content: space-around; }
  .sokal-sm-justify-evenly {
    justify-content: space-evenly; }
  .sokal-sm-justify-stretch {
    justify-content: stretch; }
  .sokal-sm-flex-wrap {
    flex-wrap: wrap; }
  .sokal-sm-flex-nowrap {
    flex-wrap: nowrap; }
  .sokal-sm-grow {
    flex-grow: 1; }
  .sokal-sm-grow-0 {
    flex-grow: 0; }
  .sokal-sm-gap {
    gap: 15px;
    gap: var(--sokal-gap-value, 15px); }
  .sokal-sm-gap-0 {
    gap: 0; } }

@media only screen and (min-width: 992px) {
  .text-md-left {
    text-align: left; }
  .text-md-center {
    text-align: center; }
  .text-md-right {
    text-align: right; }
  .sokal-md-block {
    display: block; }
  .sokal-md-inline-block {
    display: inline-block; }
  .sokal-md-flex {
    display: flex; }
  .sokal-md-inline-flex {
    display: inline-flex; }
  .sokal-md-flex-row {
    flex-direction: row; }
  .sokal-md-flex-row-reverse {
    flex-direction: row-reverse; }
  .sokal-md-flex-col {
    flex-direction: column; }
  .sokal-md-flex-col-reverse {
    flex-direction: column-reverse; }
  .sokal-md-items-start {
    align-items: start; }
  .sokal-md-items-end {
    align-items: end; }
  .sokal-md-items-center {
    align-items: center; }
  .sokal-md-items-stretch {
    align-items: stretch; }
  .sokal-md-justify-normal {
    justify-content: normal; }
  .sokal-md-justify-start {
    justify-content: start; }
  .sokal-md-justify-end {
    justify-content: end; }
  .sokal-md-justify-center {
    justify-content: center; }
  .sokal-md-justify-between {
    justify-content: space-between; }
  .sokal-md-justify-around {
    justify-content: space-around; }
  .sokal-md-justify-evenly {
    justify-content: space-evenly; }
  .sokal-md-justify-stretch {
    justify-content: stretch; }
  .sokal-md-flex-wrap {
    flex-wrap: wrap; }
  .sokal-md-flex-nowrap {
    flex-wrap: nowrap; }
  .sokal-md-grow {
    flex-grow: 1; }
  .sokal-md-grow-0 {
    flex-grow: 0; }
  .sokal-md-gap {
    gap: 15px;
    gap: var(--sokal-gap-value, 15px); }
  .sokal-md-gap-0 {
    gap: 0; } }

@media only screen and (min-width: 1200px) {
  .text-lg-left {
    text-align: left; }
  .text-lg-center {
    text-align: center; }
  .text-lg-right {
    text-align: right; }
  .sokal-lg-block {
    display: block; }
  .sokal-lg-inline-block {
    display: inline-block; }
  .sokal-lg-flex {
    display: flex; }
  .sokal-lg-inline-flex {
    display: inline-flex; }
  .sokal-lg-flex-row {
    flex-direction: row; }
  .sokal-lg-flex-row-reverse {
    flex-direction: row-reverse; }
  .sokal-lg-flex-col {
    flex-direction: column; }
  .sokal-lg-flex-col-reverse {
    flex-direction: column-reverse; }
  .sokal-lg-items-start {
    align-items: start; }
  .sokal-lg-items-end {
    align-items: end; }
  .sokal-lg-items-center {
    align-items: center; }
  .sokal-lg-items-stretch {
    align-items: stretch; }
  .sokal-lg-justify-normal {
    justify-content: normal; }
  .sokal-lg-justify-start {
    justify-content: start; }
  .sokal-lg-justify-end {
    justify-content: end; }
  .sokal-lg-justify-center {
    justify-content: center; }
  .sokal-lg-justify-between {
    justify-content: space-between; }
  .sokal-lg-justify-around {
    justify-content: space-around; }
  .sokal-lg-justify-evenly {
    justify-content: space-evenly; }
  .sokal-lg-justify-stretch {
    justify-content: stretch; }
  .sokal-lg-flex-wrap {
    flex-wrap: wrap; }
  .sokal-lg-flex-nowrap {
    flex-wrap: nowrap; }
  .sokal-lg-grow {
    flex-grow: 1; }
  .sokal-lg-grow-0 {
    flex-grow: 0; }
  .sokal-lg-gap {
    gap: 15px;
    gap: var(--sokal-gap-value, 15px); }
  .sokal-lg-gap-0 {
    gap: 0; } }

</style>



<!-- SOKAL MODERN STYLES -->

<style>
    .sokal-modern-styles {
      --sokal-gap-value: 1em;
      font-size: 15px;
    }
  
    .sokal-modern-styles .horizontal-scroll-component .scroll-horizontal {
      padding: 1em 0;
      background-color: transparent;
    }
  
    .sokal-modern-styles .horizontal-scroll-component .scroll-horizontal>*:last-child {
      margin-right: 0;
    }
  
    .sokal-modern-styles .horizontal-scroll-controls {
      padding: 1em 1em 0 0;
    }
  
    .sokal-modern-styles .horizontal-scroll-controls .sokal-gap {
      --sokal-gap-value: 0.5em;
    }
  
    .sokal-modern-styles .sokal-link,
    .sokal-modern-styles .sokal-btn {
      --sokal-gap-value: 0.5em;
    }
  
    @media only screen and (max-width: 1512px) {
      .sokal-modern-styles .horizontal-scroll-component .scroll-horizontal {
        padding: 1em;
      }
  
      .sokal-modern-styles .sokal-container .sokal-fullwidth-block {
        width: calc(100% + 2.8em);
        margin-left: -1.4em;
      }
    }
  
    @media only screen and (max-width: 1500px) {
      .sokal-modern-styles .sokal-container .sokal-fullwidth-block {
        width: calc(100% + 2em);
        margin-left: -1em;
      }
    }
  
    .sokal-modern-styles h1,
    .sokal-modern-styles .h1 {
      font-size: 2.8em;
    }
  
    .sokal-modern-styles h2,
    .sokal-modern-styles .h2 {
      font-size: 2.4em;
    }
  
    .sokal-modern-styles h3,
    .sokal-modern-styles .h3 {
      font-size: 1.6em;
    }
  
    .sokal-modern-styles h4,
    .sokal-modern-styles .h4 {
      font-size: 1.33em;
    }
  
    .sokal-modern-styles p,
    .sokal-modern-styles .text1 {
      font-size: 1.07em;
    }
  
    .sokal-modern-styles .text2 {
      font-size: 0.93em;
    }
  
    .sokal-modern-styles .text3 {
      font-size: 0.8em;
    }
  
    .sokal-modern-styles .text-light {
      opacity: 0.8;
    }
  
    .sokal-modern-styles .text-lighter {
      opacity: 0.4;
    }
  
    .sokal-modern-styles .text-lightest {
      opacity: 0.2;
    }
  
    .sokal-modern-styles .subhead1 {
      font-size: 0.93em;
      text-transform: uppercase;
      letter-spacing: 0.1em;
    }
  
    .sokal-modern-styles .subhead-alt {
      width: fit-content;
      padding: 0 0.5em 0.5em 0.5em;
      border-bottom: solid 1px;
      border-radius: 0;
    }
  
    .sokal-modern-styles .subhead-alt.text-left {
      padding: 0 1em 0.5em 0;
    }
  
    .sokal-modern-styles .subhead-alt.text-right {
      padding: 0 0 0.5em 1em;
    }
  
    .sokal-modern-styles .font-size-base {
      font-size: 1em;
    }
  
    .sokal-modern-styles .sokal-btn,
    .sokal-modern-styles .sokal-link {
      font-size: 0.93em;
      line-height: normal;
    }
  
    .sokal-modern-styles .sokal-btn {
      width: auto;
      min-height: auto;
      padding: 0.7em 1.34em;
    }
  
    .sokal-modern-styles .sokal-btn.has-border-radius {
      border-radius: 4px;
      border-radius: var(--sokal-has-border-radius-value, 4px);
    }
  
    .sokal-modern-styles .sokal-btn-slim {
      padding: 0.5em 2em;
    }
  
    .sokal-modern-styles .accordion .panel {
      border: 0;
      border-radius: 0;
      border-color: transparent;
      background-color: transparent;
      -webkit-box-shadow: none;
      box-shadow: none;
    }
  
    .sokal-modern-styles .accordion .panel-title {
      font-size: inherit;
    }
  
    .sokal-modern-styles .accordion .panel-heading {
      padding: 1.3em 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  
    .sokal-modern-styles .accordion .panel-heading [data-toggle="collapse"].collapsed .panel-heading-icons>*:not(.sokal-open) {
      display: none;
    }
  
    .sokal-modern-styles .accordion .panel-heading [data-toggle="collapse"]:not(.collapsed) .panel-heading-icons>*:not(.sokal-close) {
      display: none;
    }
  
    .sokal-modern-styles .accordion .panel-body {
      padding: 2em 0;
    }
  
    .sokal-modern-styles .accordion.panel-group .panel {
      border-radius: 0;
    }
  
    .sokal-modern-styles .accordion.panel-group .panel-heading {
      border-bottom: solid 1px #DDE3E8;
    }
  
    .sokal-modern-styles .accordion.panel-group .panel-heading a:hover,
    .sokal-modern-styles .accordion.panel-group .panel-heading a:active,
    .sokal-modern-styles .accordion.panel-group .panel-heading a:focus {
      color: inherit;
    }
  
    .sokal-modern-styles .accordion.panel-group .panel-heading+.panel-collapse>.panel-body,
    .sokal-modern-styles .accordion.panel-group .panel-heading+.panel-collapse>.list-group {
      border: 0;
    }
</style>



<style scoped>
/* INFINITI */
  #featured-vehicles-component-v2[data-brand="infiniti"] .sokal-btn::after {
    display: none;
  }

  #featured-vehicles-component-v2[data-brand="infiniti"] .sokal-btn {
    background-color: var(--primary-color, #020B24);
    color: var(--primary-light, #ffffff);
    border: 3px solid var(--primary-color, #000000);
  }
  #featured-vehicles-component-v2[data-brand="infiniti"] .sokal-btn:hover,
  #featured-vehicles-component-v2[data-brand="infiniti"] .sokal-btn:focus {
    background-color: var(--primary-light, #ffffff);
    color: var(--primary-color, #020B24);
  }
  #featured-vehicles-component-v2[data-brand="infiniti"] .fv-year {
    border-bottom-width: 1px;
  }
  #featured-vehicles-component-v2[data-brand="infiniti"] .fv-car-data .sokal-btn:hover .sokal-btn-copy {
    transform: none;
  }
  /* FORD */
  #featured-vehicles-component-v2[data-brand="ford"] .sokal-media-container {
    padding-top: 70%;
  }
</style>
